export default __webpack_public_path__ + "static/media/tv.8726378e.gif";